module.exports = __webpack_public_path__ + "static/media/LFT.143211e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/keyboard/LFT.png
// module id = 185
// module chunks = 0